<template>
  <div>
    <template v-for="(item, index) in options">
      <template v-if="values.includes(item.value)">
        <!-- 出现字典多个值拼接的情况（请销点部分的工作地点可多选） -->
        <span
          v-if="values.length > 1"
          :key="item.value"
          :index="index"
        >{{ item.label }}、</span>
        <a-tag
          v-else-if="tagType"
          :key="item.value"
          :index="index"
          :color="tagColor[index]"
        >{{ item.label }}
        </a-tag>
        <span
          v-else
          :key="item.value"
          :index="index"
        >{{ item.label }}</span>
      </template>
    </template>
  </div>
</template>
<script>
export default {
  name: 'DictText',
  props: {
    options: {
      type: Array,
      default: null
    },
    tagType: {
      type: Boolean,
      default: false
    },
    tagColor: {
      type: Array,
      default: ['pink', 'red', 'orange', 'blue', 'cyan']
    },
    value: [Number, String, Array]
  },
  computed: {
    values() {
      if (this.value !== null && typeof this.value !== 'undefined') {
        return Array.isArray(this.value) ? this.value : [String(this.value)]
      } else {
        return []
      }
    }
  }
}
</script>
<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
